export const ENV = process.env.NEXT_PUBLIC_ENVIRONMENT || 'development';
export const VERSION = process.env.NEXT_PUBLIC_VERSION;
export const API_HOST = process.env.NEXT_PUBLIC_API_HOST;
export const MIXPANEL_TOKEN =
  process.env.NEXT_PUBLIC_MIXPANEL_TOKEN || 'fake token required for mixpanel';

export const isProd = ENV === 'production';
export const isStaging = ENV === 'staging';
